<h1 mat-dialog-title>Orphan Deal Cleaner</h1>
@if (transactionIds$ | async; as transactionIds) {
  <div class="container" mat-dialog-content>
    <p>The following deals are the orphan deals. Please select the deals you want to delete.</p>
    @if (limitReached) {
      <semeris-warning>Only the first {{ LIMIT }} deals are shown.</semeris-warning>
    }
    <form [formGroup]="formGroup">
      @for (transactionId of transactionIds; track transactionId) {
        <div class="slide-toggle-form-field selectable">
          <mat-slide-toggle color="accent" [formControlName]="transactionId">{{ transactionId }}</mat-slide-toggle>
        </div>
      }
      @if (transactionIds?.length === 0) {
        <span>No orphan deals found</span>
      }
    </form>
  </div>
  <div class="actions" mat-dialog-actions align="end">
    <button semerisButton variant="text" mat-dialog-close>Cancel</button>
    <button
      semerisButton
      variant="raised"
      cdkFocusInitial
      (confirm)="deleteSelected()"
      confirmTitle="Delete selected deals"
      confirmText="Are you sure you want to delete the selected deals?"
      confirmButtonText="Delete selected deals"
      confirmColor="warn"
      color="warn"
    >
      Delete selected deals
    </button>
  </div>
} @else {
  <semeris-loader [loading]="true" [inline]="true" [style.minHeight.px]="50"></semeris-loader>
}
